import Nav from "./../Page/Share/Nav/Nav";
const Post18 = () => {
  return (
    <div>
      <div className="container">
        <Nav></Nav>

        <div className="infowork">
          {/* items Title} */}
          <h2>
            Airtime Brand Guidelines
          </h2>
          {/* items?.Description */}
          <p>

          </p>
          {/* img section */}
          <img src="https://i.ibb.co/myvk26W/Airtime-Brand-Guideline-01.jpg" alt="" />
          <img src="https://i.ibb.co/Dbj6zF7/Airtime-Brand-Guideline-02.jpg" alt="" />
          <img src="https://i.ibb.co/Bj70Mn4/Airtime-Brand-Guideline-03.jpg" alt="" />
          <img src="https://i.ibb.co/gm5nZnw/Airtime-Brand-Guideline-04.jpg" alt="" />
          <img src="https://i.ibb.co/pKYfxMP/Airtime-Brand-Guideline-05.jpg" alt="" />
          <img src="https://i.ibb.co/37RMFh4/Airtime-Brand-Guideline-06.jpg" alt="" />
          <img src="https://i.ibb.co/DtW058y/Airtime-Brand-Guideline-07.jpg" alt="" />
          <img src="https://i.ibb.co/3W2MQ6C/Airtime-Brand-Guideline-08.jpg" alt="" />
          <img src="https://i.ibb.co/nLwTDHd/Airtime-Brand-Guideline-09.jpg" alt="" />
          <img src="https://i.ibb.co/8zgq5QN/Airtime-Brand-Guideline-10.jpg" alt="" />
          <img src="https://i.ibb.co/wwPStrj/Airtime-Brand-Guideline-11.jpg" alt="" />
          <img src="https://i.ibb.co/f2gF05W/Airtime-Brand-Guideline-12.jpg" alt="" />
          <img src="https://i.ibb.co/c3kwx5h/Airtime-Brand-Guideline-13.jpg" alt="" />
          <img src="https://i.ibb.co/HTFmZ8F/Airtime-Brand-Guideline-14.jpg" alt="" />
          <img src="https://i.ibb.co/W0FfTYZ/Airtime-Brand-Guideline-15.jpg" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <p>

          </p>
        </div>
      </div>
    </div>
  );
};

export default Post18;
